import { render, staticRenderFns } from "./XreportView.vue?vue&type=template&id=0198395c"
import script from "./XreportView.vue?vue&type=script&lang=js"
export * from "./XreportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports